import { useDispatch } from 'react-redux';
import {
  postCrmEvent,
  postSaveNExitCrmEvent,
} from '../../store/actions/crmEvent/crmEventActions';

export const useCrmEvent = () => {
  const dispatch = useDispatch();
  return (applicationUid, data = null, onSuccess, onError) => {
    dispatch(
      postCrmEvent({
        applicationUid,
        data,
        onSuccess,
        onError,
      }),
    );
  };
};

export const useSaveExitCrmEvent = () => {
  const dispatch = useDispatch();
  return (applicationUid, data = {}, onSuccess, onError) => {
    dispatch(
      postSaveNExitCrmEvent({
        applicationUid,
        data,
        onSuccess,
        onError,
      }),
    );
  };
};
